import React, { useEffect, useState } from "react";
import styles from "./OrderList.module.css"; // CSS Module import
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import search from "../../../assests/search.svg";
import eyeIcon from "../../../assests/eyeIcon.svg";
import filterIcon from "../../../assests/filterIcon.svg";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import uploadsvg from "../../../assests/uploadsvg.svg";
import unableImage from "../../../assests/unableImage.svg";
import retryicon from "../../../assests/retryicon.svg";
import emotions7 from "../../../assests/emotions7.svg";
import moment from "moment-timezone";
import Table from "react-bootstrap/Table";

const OrdersListComp = ({
  filteredCityList,
  onSearchInputChange,
  loading,
  fetchOrderListNext,
  data,
  handleDateChange,
  handleOpen,
  pickDate,
  rowColors,
  handleDrag,
  handleDrop,
  onButtonClick,
  inputRef,
  imageDropped,
  previewImage,
  handleClickImg,
  handleCloseD,
  handleChangeImage,
  orderFound,
  handleRetry,
  handleClickOpen,
  showFileInput,
  open,
  handleFocus,
  handleBlur,
  onSearchInputKeyDown,
  searchOrderValue,
  isLoading,
  searchOption,
  tableContainerRef,
  orderSearchViaCity,
  handleClose,
  openFilter,
  filteredList,
  handleOpenAmount,
  openFilterAmount,
  orderSearchViaAmount,
  handleApply,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  onSearchClick,
  handleCheckboxChange,
  selectedCity,
  selectedAmount,
  removeDuplicates,
  handleCancelSelection,
  handleEndTimeChange,
  handleStartTimeChange,
  searchAmountValue,
  handleAmountInputChange,
  handleApplyFilter
}) => {
  const navigate = useNavigate();
  const { orderid } = useParams();
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [ctlist, setctlist] = useState(null);
  const uniqueCities = removeDuplicates(ctlist, "city");
  const uniqueAmounts = removeDuplicates(ctlist, "amount");

  useEffect(() => {
    if (!ctlist || !ctlist[0]) {
      setctlist(filteredList);
    }
  }, [filteredList]);

  const handleRowClick = (e, orderid) => {
    navigate(`/home/ordersview/${orderid}`);
  };
  
  const arrowClick = () => {
    navigate("/");
  };

  // Show loading spinner while data is being fetched
  if (isLoading || loading) {
    return (
      <div className={styles.ordersContainerUnique}>
        <Sidebar />
        <div className={styles.ordersLoadingCenterUnique}>
          <div className={styles.loadingSpinnerWrapperUnique}>
            <CircularProgress size={60} thickness={4} className={styles.loadingSpinnerUnique} />
            <p className={styles.loadingTextUnique}>Loading orders...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.ordersContainerUnique}>
      <Sidebar />

      <div className={styles.ordersContentUnique}>
        <div className={styles.ordersHeaderUnique}>
          <button onClick={arrowClick} className={styles.backButtonUnique}>
            <img src={leftArrow} alt="Back" className={styles.backIconUnique} />
          </button>
          <h1 className={styles.ordersTitleUnique}>Orders</h1>
        </div>

        <div className={styles.searchSectionUnique}>
          <div className={styles.searchBarWrapperUnique}>
            <input
              type="search"
              className={styles.searchInputUnique}
              placeholder="Search by Mobile Number / Search by Order ID / Mini Order ID"
              onFocus={handleFocus}
              onBlur={handleBlur}
              value={searchOrderValue}
              onChange={onSearchInputChange}
              onKeyDown={onSearchInputKeyDown}
            />
            <button className={styles.searchButtonUnique} onClick={onSearchClick}>
              <img src={search} alt="Search" className={styles.searchIconUnique} />
            </button>
          </div>

          <Button
            onClick={handleClickOpen}
            variant="contained"
            className={styles.uploadButtonUnique}
          >
            <img src={uploadsvg} alt="Upload" className={styles.uploadIconUnique} />
            <span className={styles.uploadTextUnique}>Upload Screenshot</span>
          </Button>
        </div>

        <div className={styles.orderFiltersSectionUnique}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <div className={styles.orderDateFiltersUnique}>
              <div className={styles.datePickerWrapperUnique}>
                <DatePicker
                  label="Select Date"
                  value={pickDate}
                  onChange={handleDateChange}
                  maxDate={moment()}
                  renderInput={(params) => (
                    <TextField {...params} className={styles.filterDateInputUnique} />
                  )}
                />
              </div>

              <div className={styles.startTimePickerWrapperUnique}>
                <TimePicker
                  label="Start Time"
                  value={startTime}
                  onChange={handleStartTimeChange}
                  renderInput={(params) => (
                    <TextField {...params} className={styles.filterTimeInputUnique} />
                  )}
                />
              </div>

              <div className={styles.endTimePickerWrapperUnique}>
                <TimePicker
                  label="End Time"
                  value={endTime}
                  onChange={handleEndTimeChange}
                  renderInput={(params) => (
                    <TextField {...params} className={styles.filterTimeInputUnique} />
                  )}
                />
              </div>
            </div>
          </LocalizationProvider>

          <div className={styles.amountFilterWrapperUnique}>
            <label className={styles.amountLabelUnique}>Amount</label>
            <div className={styles.amountInputWrapperUnique}>
              <span className={styles.rupeeSymbolUnique}>Rs.</span>
              <input
                type="number"
                className={styles.amountInputFieldUnique}
                placeholder="___"
                value={searchAmountValue}
                onChange={handleAmountInputChange}
                maxLength={5}
              />
            </div>
          </div>

          <div className={styles.filterButtonsWrapperUnique}>
            <Button
              onClick={handleApplyFilter}
              variant="contained"
              className={styles.applyButtonUnique}
            >
              Apply
            </Button>
            <Button
              onClick={handleCancelSelection}
              variant="outlined"
              className={styles.resetButtonUnique}
            >
              Reset
            </Button>
          </div>
        </div>

        <div className={styles.ordersTableContainerUnique} ref={tableContainerRef}>
          <Table  className={styles.ordersTableUnique}>
            <thead className={styles.tableHeaderUnique}>
              <tr className={styles.tableHeaderRowUnique}>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderDateUnique}`}>Order Date & Time</th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderOrderIdUnique}`}>Order ID</th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderMiniOrderIdUnique}`}>Mini order ID</th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderPhoneUnique}`}>Phone Number</th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderCityUnique}`}>
                  <span style={{ marginLeft: "60px" }}>City</span>
                </th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderAmountUnique}`}>Amount</th>
                <th className={`${styles.tableHeaderCellUnique} ${styles.tableHeaderActionUnique}`}></th>
              </tr>
            </thead>
            <tbody className={styles.tableBodyUnique}>
              {filteredList && filteredList.length > 0 ? (
                filteredList.map((el, index) => (
                  <tr
                    key={el.id}
                    style={{ cursor: "pointer" }}
                    className={styles.ordersRowUnique}
                    onClick={(e) => handleRowClick(e, el.id)}
                  >
                    <td className={`${styles.tableCellUnique} ${styles.tableCellDateUnique}`} data-label="Order Date & Time">
                      {moment.utc(el.createdAt).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A")}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellOrderIdUnique}`} data-label="Order ID">
                      {el.id}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellMiniOrderIdUnique}`} data-label="Mini order ID">
                      {el.dcCode}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellPhoneUnique}`} data-label="Phone Number">
                      {el.phone || "N/A"}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellCityUnique}`} data-label="City">
                      {el.city}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellAmountUnique}`} data-label="Amount">
                      {el.amount}
                    </td>
                    <td className={`${styles.tableCellUnique} ${styles.tableCellActionUnique}`} data-label="Action">
                      <img src={eyeIcon} alt="View" className={styles.ordersEyeIconUnique} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr className={styles.noOrdersRowUnique}>
                  <td colSpan="7" className={styles.noOrdersCellUnique}>
                    <div className={styles.noOrdersContainerUnique}>
                      <img src={emotions7} alt="No orders" className={styles.noOrdersIconUnique} />
                      <p className={styles.noOrdersTextUnique}>No Order Found</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Upload Screenshot Dialog */}
      <Dialog
        open={open}
        onClose={handleCloseD}
        maxWidth="md"
        fullWidth
        className={styles.uploadDialogUnique}
      >
        <DialogTitle className={styles.dialogTitleUnique}>
          Upload Screenshot
          <IconButton onClick={handleCloseD} className={styles.dialogCloseButtonUnique}>
            <CloseIcon className={styles.closeIconUnique} />
          </IconButton>
        </DialogTitle>
        <DialogContent className={styles.dialogContentUnique}>
          {orderFound ? (
            <div className={styles.uploadContainerUnique}>
              <div
                className={`${styles.dropZoneUnique} ${previewImage ? styles.hasImageUnique : ''}`}
                onDrop={handleDrop}
                onDragOver={handleDrag}
                onClick={(e) => onButtonClick(e, "box")}
              >
                {previewImage ? (
                  <img src={previewImage} alt="Preview" className={styles.previewImageUnique} />
                ) : (
                  <p className={styles.dropZoneTextUnique}>
                    Drop screenshot here, or <button className={styles.browseButtonUnique}>Browse</button>
                  </p>
                )}
              </div>

              {previewImage && (
                <Button
                  onClick={handleClickImg}
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={isLoading}
                  className={styles.submitButtonUnique}
                >
                  {isLoading ? <CircularProgress size={24} className={styles.submitSpinnerUnique} /> : "Submit"}
                </Button>
              )}

              <input
                ref={inputRef}
                type="file"
                onChange={handleChangeImage}
                style={{ display: "none" }}
                className={styles.fileInputUnique}
              />
            </div>
          ) : (
            <div className={styles.notFoundContainerUnique}>
              <img src={unableImage} alt="Unable to find" className={styles.notFoundIconUnique} />
              <h4 className={styles.notFoundTitleUnique}>Unable to find order id</h4>
              <button onClick={handleRetry} className={styles.retryButtonUnique}>
                Retry <img src={retryicon} alt="Retry" className={styles.retryIconUnique} />
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default OrdersListComp;